module.exports = __webpack_public_path__ + "img/ERS_TREE.png";